export const isNotSupportBrowser = _.pipe(
  _.getOr('', 'name'),
  _.toLower,
  _.cond([
    [_.includes(_, ['ie']), _.T],
    [_.T, _.F]
  ])
);
